"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.return_icon = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var return_icon = function return_icon(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'return-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M7.6 2.55C7.84853 2.88137 7.78137 3.35147 7.45 3.6L5.25 5.25L12.1683 5.25C13.9915 5.25 15.4094 5.96593 16.361 7.07381C17.2992 8.16602 17.75 9.59699 17.75 11C17.75 12.403 17.2992 13.834 16.361 14.9262C15.4094 16.0341 13.9915 16.75 12.1683 16.75L3 16.75C2.58579 16.75 2.25 16.4142 2.25 16C2.25 15.5858 2.58579 15.25 3 15.25L12.1683 15.25C13.5662 15.25 14.5642 14.7159 15.2232 13.9488C15.8955 13.166 16.25 12.097 16.25 11C16.25 9.90301 15.8955 8.83397 15.2232 8.05119C14.5642 7.28407 13.5662 6.75 12.1683 6.75L5.25 6.75L7.45 8.4C7.78137 8.64853 7.84853 9.11863 7.6 9.45C7.35147 9.78137 6.88137 9.84853 6.55 9.6L2.55 6.6C2.36115 6.45836 2.25 6.23607 2.25 6C2.25 5.76393 2.36115 5.54164 2.55 5.4L6.55 2.4C6.88137 2.15147 7.35147 2.21863 7.6 2.55Z',
    fill: '#4B5563'
  }));
};

exports.return_icon = return_icon;